import CourseClientProcedureAvailableContainer from './CourseClientProcedureAvailableContainer';

export default CourseClientProcedureAvailableContainer;